import React from 'react';
import { Star } from 'lucide-react';
import { formatCurrency } from '../../utils/formatters';
import { getMetricValue, getBestIndices } from './comparisonHelpers';

const MetricRow = ({ label, metricKey, results, columnIds, type, suffix, decimals = 1, highlight, source, yearIndex }) => {
    const values = columnIds.map(id => getMetricValue(results[id], metricKey, source, yearIndex));
    const bestIndices = getBestIndices(values, highlight);

    const formatValue = (val) => {
        if (type === 'badge') return val;
        if (type === 'currency') return formatCurrency(val);
        if (suffix === '%') return `${(val || 0).toFixed(decimals)}%`;
        return String(val);
    };

    const getCellClass = (val, idx) => {
        let cls = 'ct-cell';
        if (bestIndices.includes(idx)) cls += ' ct-cell-best';
        if (type === 'currency' && typeof val === 'number' && val < 0) cls += ' ct-cell-negative';
        return cls;
    };

    return (
        <>
            <div className="ct-label">{label}</div>
            {values.map((val, idx) => (
                <div key={columnIds[idx]} className={getCellClass(val, idx)}>
                    {bestIndices.includes(idx) && type !== 'badge' && (
                        <Star size={13} fill="currentColor" className="ct-best-star" aria-label="Best in row" />
                    )}
                    {type === 'badge' ? (
                        <span className="ct-badge" style={{ color: results[columnIds[idx]]?.dealRatingColor }}>
                            {val}
                        </span>
                    ) : (
                        formatValue(val)
                    )}
                </div>
            ))}
        </>
    );
};

export default MetricRow;
